var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"value":_vm.show,"outline":"","transition":"scale","type":_vm.alertType,"dismissible":_vm.dismissible}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }